export default {
    prototype: {
        defaultMsg: "暂无内容",
        defaultTitle: "提示",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
    },
    currentAnswersUnavailable: "当前答案不可查看",
    separator: "、",
};
